import React from "react"
import styled from "styled-components"
import { Link, useStaticQuery, graphql } from "gatsby"
// import excerptHtml from "excerpt-html"
// import { Img } from "wordsby-components"
// import material ui
import Typography from "@material-ui/core/Typography"
// import Grid from "@material-ui/core/Grid"

// import app components
import HeroImage from "../HeroImage"

import CircleLogo from "../../../static/logos/circle-logo-footer.svg"

const Footer = () => {
  const { copyright, services, footer_background_image } = useFooterQuery()
  const currentYear = new Date().getFullYear()

  return (
    <Container>
      <Content>
        <Col>
          <Services>
            {!!services &&
              services.map(item => {
                return (
                  <Item key={item.id} to={item.pathname}>
                    <Typography variant="subtitle2" color="inherit">
                      {item.post_title}
                    </Typography>
                  </Item>
                )
              })}
          </Services>
          <Typography color="inherit">
            &copy; {currentYear} {copyright}
          </Typography>
        </Col>
        <CircleLogo />
      </Content>
      {!!footer_background_image && (
        <BackgroundImage>
          <HeroImage bg={footer_background_image.url} />
        </BackgroundImage>
      )}
    </Container>
  )
}

export default Footer

const Content = styled.div`
  @media (min-width: 800px) {
    align-items: center;
  }
  justify-content: space-between;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  svg {
    flex-shrink: 0;
  }
`

const Col = styled.div``
const BackgroundImage = styled.div`
  opacity: 0.8;
  pointer-events: none;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  /* height: 398px; */
  height: 28vw;
  min-height: 398px;
  z-index: 0;
`

const Container = styled.div`
  @media (min-width: 800px) {
    padding: 200px 30px 80px;
  }
  padding: 80px 5% 30px;
  color: white;
`

const Services = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: 30px;
`
const Item = styled(Link)`
  text-decoration: none;
  color: inherit;
  margin-right: 20px;
`

const useFooterQuery = () => {
  const response = useStaticQuery(
    graphql`
      {
        wordsbyData {
          copyright
          footer_background_image {
            url {
              childImageSharp {
                fluid(
                  quality: 90
                  maxWidth: 1440
                  traceSVG: {
                    color: "#215991"
                    turdSize: 1000
                    optTolerance: 0.1
                    alphaMax: 0.1
                  }
                ) {
                  ...GatsbyImageSharpFluid_withWebp_tracedSVG
                }
              }
            }
          }
        }
        allWordsbyCollections(
          filter: { post_type: { eq: "service" } }
          sort: { order: ASC, fields: post_date }
        ) {
          edges {
            node {
              id
              post_title
              pathname
              post_date
            }
          }
        }
      }
    `
  )
  const {
    allWordsbyCollections: { edges },
    wordsbyData
  } = response

  let nodes
  if (edges) {
    nodes = edges.map(node => node.node)
  }

  const data = { services: nodes, ...wordsbyData }
  return data
}
